import PropTypes from "prop-types";
import React from "react";

import { LARGE, MEDIUM, SMALL, useDeviceInfo } from "@swa-ui/browser";
import { Layout, ListMatrix, ListScroller } from "@swa-ui/core";
import { fireSpecialOffersAnalytics } from "@swa-ui/dotcom-analytics";
import i18n from "@swa-ui/locale";
import { PlacementFactory } from "@swa-ui/placements";

import { SPECIAL_OFFER_1, SPECIAL_OFFERS } from "../../../defines/layoutType";
import styles from "./SpecialOffersCard.module.scss";

const PLACEMENT_COUNT = 1;

export const SpecialOffersCard = (props) => {
  const { placementIds } = props;
  const { isLargeOrXlarge, screenSize } = useDeviceInfo();
  const layoutType = placementIds.length === PLACEMENT_COUNT ? SPECIAL_OFFER_1 : SPECIAL_OFFERS;

  return screenSize === SMALL || (screenSize === MEDIUM && layoutType === SPECIAL_OFFERS)
    ? renderListScroller()
    : renderListMatrix();

  function renderListScroller() {
    return (
      <Layout center>
        <ListScroller {...getListScrollerProps()} />
      </Layout>
    );
  }

  function renderListMatrix() {
    return (
      <Layout center={isLargeOrXlarge} sides={screenSize === LARGE}>
        <ListMatrix {...getListMatrixProps()} />
      </Layout>
    );
  }

  function getListScrollerProps() {
    return {
      "aria-label-current-page": i18n("SpecialOffersCard__ARIA_LABEL_CURRENT_PAGE"),
      "aria-label-focus-change-next": i18n("SpecialOffersCard__ARIA_LABEL_FOCUS_CHANGE_NEXT"),
      "aria-label-focus-change-previous": i18n(
        "SpecialOffersCard__ARIA_LABEL_FOCUS_CHANGE_PREVIOUS"
      ),
      "aria-label-next": i18n("SpecialOffersCard__ARIA_LABEL_NEXT"),
      "aria-label-page-count": i18n("SpecialOffersCard__ARIA_LABEL_PAGE_COUNT"),
      "aria-label-previous": i18n("SpecialOffersCard__ARIA_LABEL_PREVIOUS"),
      itemClassName: styles.item,
      items: placementIds.map((placementId) => renderSpecialOfferPlacement(placementId)),
      numberOfColumns: 2,
      onClick: fireSpecialOffersAnalytics,
      showPositionIndicator: false,
    };
  }

  function renderSpecialOfferPlacement(placementId) {
    return (
      <PlacementFactory
        additionalProps={{ layoutType }}
        className={styles.specialOffersPlacementContainer}
        id={placementId}
      />
    );
  }

  function getListMatrixProps() {
    return {
      center: true,
      itemClassName: styles.listRow,
      items: placementIds.map((placementId) => ({
        content: renderSpecialOfferPlacement(placementId),
      })),
      numberOfColumns: placementIds.length,
    };
  }
};

SpecialOffersCard.displayName = "SpecialOffersCard";
SpecialOffersCard.propTypes = {
  /** Array of placement id's. */
  placementIds: PropTypes.array.isRequired,
};
